import { SET_RISK_COLUMNS } from './action-types';

export const setRiskColumns = (riskColumns) => ({
  type: SET_RISK_COLUMNS,
  payload: {
    riskColumns,
  },
});
